export const genderLookup = (gender) => {
  if (gender === 'M') return 'Male';
  else if (gender === 'F') return 'Female';
  else if (gender === 'NB') return 'Non-Binary';
  return null;
};
